












































import { Component, Prop, Vue } from 'vue-property-decorator';
import { validateEmail, validateNotEmpty } from '@/utils/form-validation';
import Icon from '@/main-components/common/Icon.vue';
import { OnSubmitInput } from './Form.vue';
import Label from './Label.vue';

@Component({
  components: { Icon, Label },
})
export default class Input extends Vue {
  @Prop({ default: '' })
  placeholder: string;

  @Prop({ default: '' })
  name: string;

  @Prop({ default: 'text' })
  type: string;

  @Prop({ default: '' })
  initialInput: string;

  @Prop({ default: false })
  maxLength: number | boolean;

  @Prop({ default: false })
  maxNumber: number | boolean;

  @Prop({ default: false })
  minNumber: number | boolean;

  @Prop({ default: null })
  icon: string | null;

  @Prop({ default: true })
  isIconFill: boolean;

  @Prop({ default: false })
  showLabel: boolean;

  // NOTE: Validation Prop ---------------------
  @Prop({ default: false })
  isRequired: boolean;

  @Prop({ default: false })
  isEmail: boolean;

  @Prop({ default: null })
  hasMinimum: number;

  @Prop({ default: null })
  apiValidate: ((input: string) => Promise<boolean>) | null;
  // -------------------------------------------

  input = '';
  error: string | boolean = false;

  get inputLength() {
    return this.input ? this.input.length : 0;
  }

  get iconColor() {
    return getComputedStyle(document.body).getPropertyValue(
      '--color-gray-dark-secondary',
    );
  }

  created() {
    if (this.initialInput) {
      this.input = this.initialInput;
    }

    this.$emit('addSubmitInput', this.submitInput);
  }

  async submitInput(): Promise<OnSubmitInput> {
    let hasError = false;

    if (this.isEmail && !validateEmail(this.input)) {
      hasError = true;
      this.error = 'Not valid email';
    }

    if (this.isRequired && !validateNotEmpty(this.input)) {
      hasError = true;
      this.error = 'Cannot be empty';
    }

    if (this.hasMinimum && this.input.length < this.hasMinimum) {
      hasError = true;
      this.error = `Password must be at least ${this.hasMinimum} characters`;
    }

    if (this.apiValidate && this.input) {
      const isNotValid = await this.apiValidate(this.input);

      if (isNotValid) {
        hasError = true;
        this.error = `Coupon is not valid or has already expired`;
      }
    }

    if (!hasError) {
      this.error = false;
    }

    return {
      hasError,
      value: this.input,
      name: this.name,
    };
  }
}
